import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Showcase = ({ items, id, testId, prefix, bg, heading, blurb }) => (
  <section id={id} className={`${bg} py-28 lg:py-36`} data-testid={testId}>
    <div className="px-5 lg:px-10">
      <Reveal>
        <h2 className="font-giant text-[12vw] lg:text-[7.5vw] leading-[0.9] text-[#121110]">{heading}</h2>
        <p className="max-w-xl text-lg lg:text-xl leading-relaxed text-[#4A453F] mt-8">{blurb}</p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
        {items.map((item, i) => (
          <Reveal key={item.id} delay={(i % 3) * 0.1}>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group block"
              data-cursor="view"
              data-testid={`${prefix}-card-${i}`}
            >
              <div className="relative overflow-hidden rounded-2xl border border-[#121110]/10 bg-[#121110]">
                <img
                  src={item.image}
                  alt=""
                  aria-hidden="true"
                  className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl opacity-50 transition-transform duration-700 ease-[cubic-bezier(0.76,0,0.24,1)] group-hover:scale-125"
                />
                <img
                  src={item.image}
                  alt={item.name}
                  className="relative w-full aspect-[4/3] object-contain"
                />
              </div>
              <div className="flex items-start justify-between gap-4 mt-6">
                <div className="min-w-0">
                  <h3 className="font-giant text-2xl lg:text-3xl text-[#121110]">{item.name}</h3>
                  {item.tagline && <p className="text-[#4A453F] leading-relaxed mt-2" data-testid={`${prefix}-tagline-${i}`}>{item.tagline}</p>}
                </div>
                <span className="w-11 h-11 shrink-0 rounded-full border border-[#121110] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#121110] group-hover:text-[#EFEAE1]">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Showcase;
